import { ButtonBase } from '@mui/material';
import { BaseButtonBaseProps } from './BaseButtonBase.types';
import { ReactNode } from 'react';

/**
 * The MUI ButtonBase control that serves as a base control we wrap off of to make some of our buttons.
 *
 * @param type - {@link BaseButtonBaseProps.type type} description.
 * @param title - {@link BaseButtonBaseProps.title title} description.
 * @param ariaLabel - {@link BaseButtonBaseProps.ariaLabel ariaLabel} description.
 * @param className - {@link BaseButtonBaseProps.className className} description.
 * @param classes - {@link BaseButtonBaseProps.classes classes} description.
 * @param style - {@link BaseButtonBaseProps.style style} description.
 * @param focusVisibleClassName - {@link BaseButtonBaseProps.focusVisibleClassName focusVisibleClassName} description.
 * @param TouchRippleProps - {@link BaseButtonBaseProps.TouchRippleProps TouchRippleProps} description.
 * @param ariaChecked - {@link BaseButtonBaseProps.ariaChecked ariaChecked} description.
 * @param disabled - {@link BaseButtonBaseProps.disabled disabled} description.
 * @param onClick - {@link BaseButtonBaseProps.onClick onClick} description.
 * @param children - {@link BaseButtonBaseProps.children children} description.
 */
export const BaseButtonBase = ({
    onClick,
    type,
    title,
    ariaLabel,
    className,
    children,
    focusVisibleClassName,
    TouchRippleProps,
    ariaChecked,
    disabled,
    classes,
    style,
}: BaseButtonBaseProps): ReactNode => {
    return (
        <ButtonBase
            type={type}
            title={title}
            aria-label={ariaLabel}
            onClick={onClick}
            className={className}
            focusVisibleClassName={focusVisibleClassName}
            TouchRippleProps={TouchRippleProps}
            aria-checked={ariaChecked}
            disabled={disabled}
            classes={classes}
            style={style}
        >
            {children}
        </ButtonBase>
    );
};